/**
 * RJSF names every generated element after its path through the schema, joined
 * with underscores and prefixed with the form's id: the root object is `4`, and
 * a field three levels down is `4_lifecycle_backup_schedule`. The suffixed ids
 * follow the same rule — `4__title`, `4_compute__description`.
 *
 * The templates need to tell the root apart from everything under it, and the
 * path is the only thing that says so reliably. They used to ask whether the
 * uiSchema was an empty object, which is true of the root *and* of every
 * nested object that was given no ui options — so an object four levels down
 * was styled as the form's own heading.
 */

/** strip RJSF's `__title` / `__description` suffix, leaving the field path */
const toPath = (id?: string): string => String(id ?? '').replace(/__[a-z]+$/, '');

/** the root object of the form, as opposed to anything nested inside it */
export const isRootId = (id?: string): boolean => {
    const path = toPath(id);
    return path.length > 0 && !path.includes('_');
};

/** an item of an array, e.g. `4_disks_0` or `4_disks_0_mount` */
export const isArrayItemId = (id?: string): boolean => /_\d+$/.test(String(id ?? ''));

/** how deep below the root a field sits: `4` is 0, `4_compute_accelerator` is 2 */
export const depthOfId = (id?: string): number => {
    const path = toPath(id);
    if (!path) return 0;
    return path.split('_').length - 1;
};
